// Fixed Source Type / Industry Topics / Corporate Topics labels, matching AiTaxonomy.java
// verbatim. Used by the analytics filter bar's drawer sections and by the admin clips list's
// sentiment taxonomy edit dialog - any new screen needing these lists should import from here
// instead of redeclaring its own copy.

export const SOURCE_TYPES: string[] = ['News Story', 'Press Release', 'Interview', 'Statement', 'Opinion / Column'];

export const INDUSTRY_TOPICS: string[] = [
	'Market & Competition',
	'Products, Services & Pricing',
	'Technology & Innovation',
	'Regulation & Legal',
	'Infrastructure & Supply Chain',
	'Macroeconomics & Trends',
];

export const CORPORATE_TOPICS: string[] = [
	'Corporate Governance & Finance',
	'Customer Experience & Support',
	'CSR & Sustainability',
	'Sponsorships & PR Events',
	'Crisis, Legal & Issues',
	'HR & Workforce',
	'Other',
];
